import { useField } from 'formik';

import { ProductOption } from '../ProductSelect/ProductOption';
import { ProductSelectWithSuggestedProduct } from '../ProductSelect/ProductSelectWithSuggestedProduct';

import { FormikProductSelectProps } from './FormikProductSelect';

interface FormikProductSelectWithSuggestedProductProps extends FormikProductSelectProps {
    suggestedProductName: string;
}

export const FormikProductSelectWithSuggestedProduct = ({
    onSelect,
    forceNegative = false,
    ...props
}: FormikProductSelectWithSuggestedProductProps) => {
    const [field, meta, helpers] = useField(props.name);

    const onChange = (option: ProductOption | null) => {
        if (!option) {
            helpers.setValue('');
            return;
        }
        helpers.setValue(option.value);
        onSelect?.(option.product);
    };

    return (
        <ProductSelectWithSuggestedProduct
            {...props}
            onBlur={() => {
                helpers.setTouched(true, true);
            }}
            negative={forceNegative || (meta.touched && !!meta.error)}
            value={field.value}
            onChange={onChange}
        />
    );
};
